
  import { defineComponent } from "@nuxtjs/composition-api";

  export default defineComponent({
    name: "Button",
    props: {
      hasIcon: {
        type: Boolean,
        required: false,
        default: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      secondary: {
        type: Boolean,
        required: false,
        default: false
      },
      textOnly: {
        type: Boolean,
        required: false,
        default: false
      },
      imageSrc: {
        type: String,
        required: false,
        default: ""
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    emits: ["click"],
    setup(props, { emit }) {
      return {
        clicked: () => {
          if (!props.disabled) {
            emit("click");
          }
        }
      };
    }
  });
